import { curEnvConfigAppInfoDict } from '../config'
import store from '@/store'
import { isSamePageTagByUrl } from './isSamePageTag'

export const BASE_APP_PROTOCOL_HOST = window.location.protocol + '//' + window.location.host

export function getBaseAppProtocolHost() {
  return BASE_APP_PROTOCOL_HOST
}

class RouterChangeTrigger {
  trigger = 's' // main-app s

  setTrigger(triggerName) {
    this.triggerBy = triggerName
  }

  setTriggerSubApp() {
    this.setTrigger('s')
  }

  setTriggerBaseApp() {
    this.setTrigger('base-app')
  }

  consume() {
    const trigger = this.trigger
    this.setTrigger('')
    return trigger
  }
}

export function isBaseAppUrl(fullUrl) {
  const isBaseAppUrl = String(fullUrl).startsWith(getBaseAppProtocolHost())
  if (isBaseAppUrl) {
    return true
  }
}

export function isBaseAppUrlOfSubApp(fullUrl) {
  const pat = /\/s\/.?/
  return pat.test(String(fullUrl))
}

export function isBaseAppUrlOfBaseApp(fullUrl) {
  const ifBaseAppUrl = isBaseAppUrl(fullUrl)
  const ifBaseAppUrlOfSubApp = isBaseAppUrlOfSubApp(fullUrl)

  return ifBaseAppUrl && !ifBaseAppUrlOfSubApp
}

export function isSubAppUrl(fullUrl) {
  const { base, ...subAppConfig } = curEnvConfigAppInfoDict
  const subAppConfigList = Object.values(subAppConfig)
  for (let index = 0; index < subAppConfigList.length; index++) {
    const subAppConfig = subAppConfigList[index]
    if (subAppConfig.entry && String(fullUrl).startsWith(subAppConfig.entry)) {
      return true
    }
  }

  return false
}

export function isAppInnerUrl(fullUrl) {
  return isBaseAppUrl(fullUrl) || isSubAppUrl(fullUrl)
  // if (!fullUrl) {
  //   return false
  // }

  // try {
  //   const isBaseAppUrl = String(fullUrl).startsWith(getBaseAppProtocolHost())
  //   if (isBaseAppUrl) {
  //     return true
  //   }

  //   const { base, ...subAppConfig } = curEnvConfigAppInfoDict
  //   const subAppConfigList = Object.values(subAppConfig)
  //   for (let index = 0; index < subAppConfigList.length; index++) {
  //     const subAppConfig = subAppConfigList[index]
  //     if (subAppConfig.entry && String(fullUrl).startsWith(subAppConfig.entry)) {
  //       return true
  //     }
  //   }

  //   return false
  // } catch (error) {
  //   return false
  // }
}

export function handleSubAppDocumentClick() {
  store.dispatch('pageTag/toggleSubAppDocumentClickFlag')
}

export const routerChangeTrigger = new RouterChangeTrigger()

export * from './isSamePageTag'
export { getIframeContentWindowByTagId, getIframeTagIdByWindow } from './iframeDom'
